import * as React from 'react';
import { Calculator } from './Calculator';

export const MessagingRates = () => {
  const [isShowCalc, setIsShowCalc] = React.useState(false);

  const usRates = [
    ['SMS Inbound & Outbound (per segment)', '$0.02', '$0.03'],
    ['Phone call Inbound & Outbound (per minute)', '$0.02', '$0.03'],
    ['MMS Inbound and Outbound', '$0.02', '$0.03'],
    ['WhatsApp Inbound and Outbound (per segment)', '$0.02', '$0.03'],
  ];

  const caRates = [
    ['SMS Inbound & Outbound (per segment)', '$0.02', '$0.03'],
    ['Phone call Inbound & Outbound (per minute)', '$0.02', '$0.03'],
    ['MMS Inbound and Outbound', '$0.03', '$0.04'],
    ['WhatsApp Inbound and Outbound (per segment)', '$0.02', '$0.03'],
  ];

  const usTollFreeCarrierFees = [
    ['Verizon - SMS Outbound', '', '$0.0025'],
    ['AT&T - SMS Outbound', '', '$0.0025'],
    ['T-Mobile/Sprint - SMS Inbound & Outbound', '', '$0.0025'],
    ['Verizon - MMS Outbound', '', '$0.005'],
    ['AT&T - MMS Outbound', '', '$0.003'],
    ['T-Mobile/Sprint - MMS Inbound & Outbound', '', '$0.01'],
  ];

  const usLongCodeCarrierFees = [
    ['Verizon - SMS Outbound', '', '$0.0025'],
    ['US Cellular - SMS Outbound', '', '$0.005'],
    ['AT&T - SMS Outbound', '', '$0.002'],
    ['T-Mobile/Sprint - SMS Inbound & Outbound', '', '$0.003'],
    ['Verizon - MMS Outbound', '', '$0.005'],
    ['US Cellular - MMS Outbound', '', '$0.01'],
    ['AT&T - MMS Outbound', '', '$0.0035'],
    ['T-Mobile/Sprint - MMS Inbound & Outbound', '', '$0.01'],
  ];

  const usShortCodeCarrierFees = [
    ['Verizon - SMS Outbound', '', '$0.0025'],
    ['US Cellular - SMS Inbound & Outbound', '', '$0.0035'],
    ['AT&T - SMS Outbound', '', '$0.0025'],
    ['T-Mobile - SMS Inbound & Outbound', '', '$0.0025'],
    ['Sprint - SMS Inbound & Outbound', '', '$0.005'],
    ['AT&T - MMS Outbound', '', '$0.003'],
    ['T-Mobile - MMS Outbound', '', '$0.005'],
    ['US Cellular - MMS Outbound', '', '$0.01'],
  ];

  const caCarrierFees = [
    ['Belle & Virgin - SMS Outbound', '', '$0.0085'],
    ['Belle & Virgin - SMS Inbound', '', '$0.0085'],
    ['Fido - SMS Outbound', '', '$0.006'],
    ['Freedom Mobile - SMS Outbound', '', '$0.0045'],
    ['Rogers - SMS Outbound', '', '$0.006'],
    ['Telus - SMS Outbound', '', '$0.0038'],
    ['Videotron - SMS Outbound', '', '$0.0055'],
    ['Belle & Virgin - MMS Outbound', '', '$0.016'],
    ['Belle & Virgin - MMS Inbound', '', '$0.016'],
    ['Freedom Mobile - MMS Outbound', '', '$0.0091'],
    ['Telus - MMS Outbound', '', '$0.0076'],
    ['Videotron - MMS Outbound', '', '$0.0055'],
  ];

  const internationalRates = [
    ['Andorra', '', '$0.05'],
    ['United Arab Emirates', '', '$0.04'],
    ['Afghanistan', '', '$0.10'],
    ['Antigua and Barbuda', '', '$0.05'],
    ['Anguilla', '', '$0.06'],
    ['Albania', '', '$0.10'],
    ['Armenia', '', '$0.10'],
    ['Netherlands Antilles', '', '$0.06'],
    ['Angola', '', '$0.08'],
    ['Argentina', '', '$0.08'],
    ['American Samoa', '', '$0.14'],
    ['Austria', '', '$0.11'],
    ['Australia', '', '$0.10'],
    ['Aruba', '', '$0.06'],
    ['Azerbaijan', '', '$0.17'],
    ['Bosnia and Herzegovina', '', '$0.01'],
    ['Barbados', '', '$0.06'],
    ['Bangladesh', '', '$0.09'],
    ['Belgium', '', '$0.12'],
    ['Burkina Faso', '', '$0.08'],
    ['Bulgaria', '', '$0.16'],
    ['Bahrain', '', '$0.14'],
    ['Burundi', '', '$0.12'],
    ['Benin', '', '$0.13'],
    ['Bermuda', '', '$0.06'],
    ['Brunei', '', '$0.06'],
    ['Bolivia', '', '$0.08'],
    ['Brazil', '', '$0.07'],
    ['Bahamas', '', '$0.06'],
    ['Bhutan', '', '$0.06'],
    ['Botswana', '', '$0.11'],
    ['Belarus', '', '$0.10'],
    ['Belize', '', '$0.08'],
    ['DR Congo', '', '$0.11'],
    ['Central Africa', '', '$0.06'],
    ['Congo', '', '$0.08'],
    ['Switzerland', '', '$0.01'],
    ['Ivory Coast', '', '$0.18'],
    ['Cook Islands', '', '$0.06'],
    ['Chile', '', '$0.09'],
    ['Cameroon', '', '$0.17'],
    ['China', '', '$0.08'],
    ['Colombia', '', '$0.06'],
    ['Costa Rica', '', '$0.08'],
    ['Cuba', '', '$0.10'],
    ['Cape Verde', '', '$0.09'],
    ['Cyprus', '', '$0.10'],
    ['Czech Republic', '', '$0.08'],
    ['Germany', '', '$0.12'],
    ['Djibouti', '', '$0.12'],
    ['Denmark', '', '$0.10'],
    ['Dominica', '', '$0.06'],
    ['Dominican Republic', '', '$0.07'],
    ['Algeria', '', '$0.09'],
    ['Ecuador', '', '$0.11'],
    ['Estonia', '', '$0.12'],
    ['Egypt', '', '$0.10'],
    ['Eritrea', '', '$0.12'],
    ['Spain', '', '$0.1501'],
    ['Ethiopia', '', '$0.08'],
    ['Finland', '', '$0.10'],
    ['Fiji', '', '$0.12'],
    ['Falkland Islands', '', '$0.08'],
    ['Micronesia', '', '$0.08'],
    ['Faroe Islands', '', '$0.07'],
    ['France', '', '$0.12'],
    ['Gabon', '', '$0.08'],
    ['United Kingdom', '', '$0.07'],
    ['Grenada', '', '$0.07'],
    ['Georgia', '', '$0.11'],
    ['French Guiana', '', '$0.22'],
    ['Guernsey', '', '$0.05'],
    ['Ghana', '', '$0.08'],
    ['Gibraltar', '', '$0.08'],
    ['Greenland', '', '$0.08'],
    ['Gambia', '', '$0.08'],
    ['Guinea', '', '$0.18'],
    ['Guadeloupe', '', '$0.11'],
    ['Equatorial Guinea', '', '$0.05'],
    ['Greece', '', '$0.08'],
    ['Guatemala', '', '$0.08'],
    ['Guam', '', '$0.11'],
    ['Guinea-Bissau', '', '$0.18'],
    ['Guyana', '', '$0.06'],
    ['Hong Kong', '', '$0.08'],
    ['Honduras', '', '$0.08'],
    ['Croatia', '', '$0.08'],
    ['Haiti', '', '$0.08'],
    ['Hungary', '', '$0.11'],
    ['Indonesia', '', '$0.06'],
    ['Ireland', '', '$0.13'],
    ['Israel', '', '$0.03'],
    ['India', '', '$0.01'],
    ['Iraq', '', '$0.13'],
    ['Iran', '', '$0.06'],
    ['Iceland', '', '$0.03'],
    ['Italy', '', '$0.1766'],
    ['Jersey', '', '$0.05'],
    ['Jamaica', '', '$0.08'],
    ['Jordan', '', '$0.11'],
    ['Japan', '', '$0.10'],
    ['Kenya', '', '$0.08'],
    ['Kyrgyzstan', '', '$0.07'],
    ['Cambodia', '', '$0.13'],
    ['Kiribati', '', '$0.10'],
    ['Comoros', '', '$0.08'],
    ['St Kitts and Nevis', '', '$0.11'],
    ['Korea', '', '$0.06'],
    ['Kuwait', '', '$0.08'],
    ['Cayman Islands', '', '$0.06'],
    ['Kazakhstan', '', '$0.10'],
    ['Laos PDR', '', '$0.10'],
    ['Lebanon', '', '$0.08'],
    ['St Lucia', '', '$0.06'],
    ['Liechtenstein', '', '$0.08'],
    ['Sri Lanka', '', '$0.07'],
    ['Liberia', '', '$0.08'],
    ['Lesotho', '', '$0.12'],
    ['Lithuania', '', '$0.08'],
    ['Luxembourg', '', '$0.07'],
    ['Latvia', '', '$0.10'],
    ['Libya', '', '$0.11'],
    ['Morocco', '', '$0.09'],
    ['Monaco', '', '$0.18'],
    ['Moldova', '', '$0.08'],
    ['Montenegro', '', '$0.05'],
    ['Madagascar', '', '$0.08'],
    ['Marshall Islands', '', '$0.14'],
    ['Macedonia', '', '$0.10'],
    ['Mali', '', '$0.12'],
    ['Myanmar', '', '$0.13'],
    ['Mongolia', '', '$0.07'],
    ['Macau', '', '$0.08'],
    ['Northern Mariana Islands', '', '$0.0867'],
    ['Martinique', '', '$0.20'],
    ['Mauritania', '', '$0.11'],
    ['Montserrat', '', '$0.06'],
    ['Malta', '', '$0.08'],
    ['Mauritius', '', '$0.10'],
    ['Maldives', '', '$0.08'],
    ['Malawi', '', '$0.08'],
    ['Mexico', '', '$0.06'],
    ['Malaysia', '', '$0.08'],
    ['Mozambique', '', '$0.08'],
    ['Namibia', '', '$0.08'],
    ['New Caledonia', '', '$0.17'],
    ['Niger', '', '$0.17'],
    ['Norfolk Island', '', '$0.08'],
    ['Nigeria', '', '$0.13'],
    ['Nicaragua', '', '$0.07'],
    ['Netherlands', '', '$0.12'],
    ['Norway', '', '$0.10'],
    ['Nepal', '', '$0.10'],
    ['Niue', '', '$0.08'],
    ['New Zealand', '', '$0.13'],
    ['Oman', '', '$0.09'],
    ['Panama', '', '$0.07'],
    ['Peru', '', '$0.08'],
    ['French Polynesia', '', '$0.21'],
    ['Papua New Guinea', '', '$0.08'],
    ['Philippines', '', '$0.08'],
    ['Pakistan', '', '$0.05'],
    ['Poland', '', '$0.08'],
    ['St Pierre and Miquelon', '', '$0.14'],
    ['Puerto Rico', '', '$0.08'],
    ['Palestinian Territory', '', '$0.08'],
    ['Portugal', '', '$0.10'],
    ['Palau', '', '$0.08'],
    ['Paraguay', '', '$0.08'],
    ['Qatar', '', '$0.07'],
    ['Reunion/Mayotte', '', '$0.27'],
    ['Romania', '', '$0.09'],
    ['Serbia', '', '$0.0842'],
    ['Russia', '', '$0.12'],
    ['Rwanda', '', '$0.08'],
    ['Saudi Arabia', '', '$0.05'],
    ['Solomon Islands', '', '$0.09'],
    ['Seychelles', '', '$0.14'],
    ['Sudan', '', '$0.08'],
    ['Sweden', '', '$0.12'],
    ['Singapore', '', '$0.08'],
    ['Slovenia', '', '$0.08'],
    ['Slovakia', '', '$0.12'],
    ['Sierra Leone', '', '$0.08'],
    ['San Marino', '', '$0.10'],
    ['Senegal', '', '$0.16'],
    ['Somalia', '', '$0.13'],
    ['Suriname', '', '$0.08'],
    ['South Sudan', '', '$0.08'],
    ['Sao Tome and Principe', '', '$0.16'],
    ['El Salvador', '', '$0.08'],
    ['Syria', '', '$0.08'],
    ['Swaziland', '', '$0.08'],
    ['Turks and Caicos Islands', '', '$0.06'],
    ['Chad', '', '$0.10'],
    ['Togo', '', '$0.08'],
    ['Thailand', '', '$0.08'],
    ['Tajikistan', '', '$0.07'],
    ['East Timor', '', '$0.13'],
    ['Turkmenistan', '', '$0.14'],
    ['Tunisia', '', '$0.10'],
    ['Tonga', '', '$0.08'],
    ['Turkey', '', '$0.03'],
    ['Trinidad and Tobago', '', '$0.10'],
    ['Tuvalu', '', '$0.12'],
    ['Taiwan', '', '$0.08'],
    ['Tanzania', '', '$0.08'],
    ['Ukraine', '', '$0.11'],
    ['Uganda', '', '$0.08'],
    ['Uruguay', '', '$0.11'],
    ['Uzbekistan', '', '$0.13'],
    ['St Vincent Grenadines', '', '$0.07'],
    ['Venezuela', '', '$0.08'],
    ['Virgin Islands, British', '', '$0.08'],
    ['Virgin Islands, U.S.', '', '$0.08'],
    ['Vietnam', '', '$0.12'],
    ['Vanuatu', '', '$0.11'],
    ['Wallis and Futuna', '', '$0.187'],
    ['Samoa', '', '$0.06'],
    ['Kosovo', '', '$0.11'],
    ['Yemen', '', '$0.11'],
    ['South Africa', '', '$0.03'],
    ['Zambia', '', '$0.08'],
    ['Zimbabwe', '', '$0.14'],
  ];

  const generateKey = (data) => `${data}_${new Date().getTime()}`;
  const createRows = (arr) => arr.map((cells) => {
    const rows = cells.map((cell) => <td key={generateKey(cell)}>{cell}</td>);
    return <tr key={generateKey(cells)}>{rows}</tr>;
  });

  return (
    <div id="messaging-rates" className="avo-ui-3 flex-col align-center" style={{ marginTop: '125px' }}>
      <div className="main-header">
        <p className="fsz-36 mb-5 center bold-900" style={{ marginTop: '50px' }}>Avochato Messaging Rates</p>
        <p className="align-self-c center fsz-16 gray mb-5" style={{ maxWidth: '510px' }}>
          Messaging costs can vary based on the type of  message, the
          destination, and the carrier of the recipient. The list below
          shows all of the rates that will apply to your account balance.
        </p>
        <p
          role="button"
          tabIndex={0}
          className="link-blue center"
          onClick={() => setIsShowCalc(!isShowCalc)}
          onKeyPress={() => setIsShowCalc(!isShowCalc)}
        >
          {isShowCalc ? 'Hide Message Calculator' : 'Show Message Calculator'}
        </p>
      </div>
      {
        isShowCalc && (
          <div
            id="balance-calculator"
            className="messaging-rate-calculator"
          >
            <Calculator />
          </div>
        )
      }
      <div className="my-25">
        <div className="section-header">
          <p className="fsz-18 orange bold-800">United States</p>
          <p className="fsz-14 mb-20">
            Apply to call minutes, SMS, MMS, and WhatsApp message segments
            sent to and from US
          </p>
        </div>
        <table className="rates-matrix" style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tr className="header">
            <td />
            <td>Annual Fee</td>
            <td>Monthly Fee</td>
          </tr>
          {createRows(usRates)}
        </table>
      </div>
      <div className="my-25">
        <div className="section-header">
          <p className="fsz-18 orange bold-800">Canada</p>
          <p className="fsz-14 mb-20">
            Apply to call minutes, SMS, MMS, and WhatsApp message segments
            sent to and from Canada
          </p>
        </div>
        <table className="rates-matrix" style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tr className="header">
            <td />
            <td>Annual Fee</td>
            <td>Monthly Fee</td>
          </tr>
          {createRows(caRates)}
        </table>
      </div>
      <div className="my-25">
        <div className="section-header">
          <p className="fsz-18 orange bold-800">Carrier Fees</p>
          <p className="fsz-14 mb-20">
            Apply to SMS and MMS messages in US and Canada
          </p>
        </div>
        <table className="rates-matrix international mb-20" style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tr className="header">
            <td>US Carrier Fees: Toll-free number (1800 number)</td>
            <td />
            <td>Monthly Fee</td>
          </tr>
          {createRows(usTollFreeCarrierFees)}
        </table>
        <table className="rates-matrix international mb-20" style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tr className="header">
            <td>US Carrier Fees: Long Code (10-digit numbers)</td>
            <td />
            <td>Monthly Fee</td>
          </tr>
          {createRows(usLongCodeCarrierFees)}
        </table>
        <table className="rates-matrix international mb-20" style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tr className="header">
            <td>US Carrier Fees: Short Code</td>
            <td />
            <td>Monthly Fee</td>
          </tr>
          {createRows(usShortCodeCarrierFees)}
        </table>
        <table className="rates-matrix international" style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tr className="header">
            <td>Canada Carrier Fees</td>
            <td />
            <td>Monthly Fee</td>
          </tr>
          {createRows(caCarrierFees)}
        </table>
      </div>
      <div className="my-25">
        <div className="section-header">
          <p className="fsz-18 orange bold-800">International</p>
          <p className="fsz-14 mb-20">
            Apply to call minutes, SMS, MMS, and WhatsApp message segments
            sent to and from US
          </p>
        </div>
        <table className="rates-matrix international" style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tr className="header">
            <td />
            <td />
            <td>Monthly Fee</td>
          </tr>
          {createRows(internationalRates)}
        </table>
      </div>
    </div>
  );
};
